import { z } from "zod";

export default {
  params: z.object({
    accountId: z.string(),
    documentId: z.string(),
  }),
  response: z.object({
    url: z.string(),
    contentType: z.string(),
    duration: z.number(),
  }),
};
